"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.Text=exports.PaymentShield=void 0;const PaymentShield=exports.PaymentShield=_styledComponents.default.div`
    display:flex;
    justify-content:center;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 16px;
    color: #2A2928;
    align-items: center;
    margin-top: 24px;
    max-width: 660px !important;
`,Text=exports.Text=_styledComponents.default.div`
  margin-left: 5px;
`;